export default __webpack_public_path__ + "static/media/Allianz.05ade14b.svg";